const DAY = 86400000;

function utc(date) {
  return new Date(`${date}T12:00:00Z`);
}

export function isoOf(at) {
  return at.toISOString().slice(0, 10);
}

export function addDays(date, days) {
  return isoOf(new Date(utc(date).getTime() + days * DAY));
}

export function monthRange(month) {
  const [y, m] = month.split("-").map(Number);
  const from = `${month}-01`;
  const last = new Date(Date.UTC(y, m, 0)).getUTCDate();
  return { from, to: `${month}-${String(last).padStart(2, "0")}` };
}

export function shiftMonth(month, by) {
  const [y, m] = month.split("-").map(Number);
  const at = new Date(Date.UTC(y, m - 1 + by, 1));
  return `${at.getUTCFullYear()}-${String(at.getUTCMonth() + 1).padStart(2, "0")}`;
}

export function monthOf(date) {
  return date.slice(0, 7);
}

export function monthLabel(month) {
  const [y, m] = month.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleDateString("en-GB", {
    month: "long",
    year: "numeric",
    timeZone: "UTC",
  });
}

export function weekStart(date) {
  const at = utc(date);
  const shift = (at.getUTCDay() + 6) % 7;
  return addDays(date, -shift);
}

export function weekRange(start) {
  return { from: start, to: addDays(start, 6) };
}

export function weekLabel(start) {
  const { from, to } = weekRange(start);
  const a = utc(from);
  const b = utc(to);
  const sameMonth = from.slice(0, 7) === to.slice(0, 7);
  const opts = { day: "numeric", month: "short", timeZone: "UTC" };
  const left = sameMonth
    ? a.toLocaleDateString("en-GB", { day: "numeric", timeZone: "UTC" })
    : a.toLocaleDateString("en-GB", opts);
  return `${left} – ${b.toLocaleDateString("en-GB", opts)}`;
}

export function dayLabelFull(date, today) {
  if (date === today) return "Today";
  if (date === addDays(today, -1)) return "Yesterday";
  return utc(date).toLocaleDateString("en-GB", {
    weekday: "short",
    day: "numeric",
    month: "short",
    timeZone: "UTC",
  });
}

export function dayTick(date) {
  return utc(date).toLocaleDateString("en-GB", { weekday: "short", day: "numeric", timeZone: "UTC" });
}

export function upTo(dates, last) {
  return dates.filter((date) => date <= last);
}

export function money(amount, currency) {
  if (!Number.isFinite(amount)) return "—";
  const code = currency || "INR";
  try {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: code,
      maximumFractionDigits: amount % 1 === 0 ? 0 : 2,
    }).format(amount);
  } catch {
    return `${code} ${amount}`;
  }
}
